import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faHome, faUser, faPlusCircle, faCalendarAlt, faEnvelope} from '@fortawesome/fontawesome-free-solid';

import './sideNavigation.scss';

class SideNavigation extends Component { 
    getNewLeadsCounter() {
        const {leads} = this.props;

        if(!leads || !leads.list) return 0;

        return leads.list.reduce((number, item) => {
            if(item.interested !== false && item.interested !== true) number++;
            return number;
        }, 0);
    }

    render() {
        const leadsCounter = this.getNewLeadsCounter();

        return (
            <nav className="mainSideNav">
                <div className="navLogo">
                    <img src='/images/logo.png' alt="SELPHO"/>
                </div>
                <div className="createEventLink">
                    <NavLink exact to="/events/create" activeClassName="active">
                        <span className="icon">
                            <FontAwesomeIcon icon={faPlusCircle}/>
                        </span> אירוע חדש
                    </NavLink>
                </div>
                <div className="navLinks">
                    {/* <NavLink exact to="/" activeClassName="active">
                        <FontAwesomeIcon icon={faHome}/>ראשי
                    </NavLink> */}
                    <NavLink exact to="/events" activeClassName="active">
                        <FontAwesomeIcon icon={faCalendarAlt}/>אירועים
                    </NavLink>
                    <NavLink exact to="/leads" activeClassName="active" className="leadsLink">
                        <div id="leadsCounter" className={`${(leadsCounter && leadsCounter > 0) ? 'show': ''}`}>{leadsCounter}</div>
                        <FontAwesomeIcon icon={faEnvelope}/>לידים
                    </NavLink>
                    <NavLink to="/profile" activeClassName="active">
                        <FontAwesomeIcon icon={faUser}/>הפרופיל שלי
                    </NavLink>
                </div>
            </nav>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer,
        leads: state.leadsReducer
    }   
}

const SideNavigationWithRedux = connect(mapStateToProps)(SideNavigation);

export {SideNavigationWithRedux as SideNavigation};


// WEBPACK FOOTER //
// ./src/components/PageTemplate/SideNavigation.jsx